import { render, staticRenderFns } from "./ClientesList.vue?vue&type=template&id=3c9399ef&scoped=true&"
import script from "./ClientesList.vue?vue&type=script&lang=js&"
export * from "./ClientesList.vue?vue&type=script&lang=js&"
import style0 from "./ClientesList.vue?vue&type=style&index=0&id=3c9399ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9399ef",
  null
  
)

export default component.exports